import React from "react";
import { useParams } from "react-router-dom";
import BrandLockup from "@/components/BrandLockup";
import EmployeeIdLabel from "@/components/ui/EmployeeIdLabel";
import { useAuth } from "@/contexts/AuthContext";
import PayrollNotificationsButton from "@/components/layout/PayrollNotificationsButton";

type ShellTopBarProps = {
  onLogout: () => Promise<void> | void;
  searchSlot?: React.ReactNode;
};

export default function ShellTopBar({
  onLogout,
  searchSlot = null,
}: ShellTopBarProps) {
  const { companyId } = useParams<{ companyId: string }>();
  const {
    firstName,
    employeeCompanyId,
    employeeSystemId,
  } = useAuth();

  const shouldShowScopedEmployeeId =
    Boolean(companyId && employeeCompanyId === companyId);

  return (
    <div className="relative z-50 w-full px-4 py-2 sm:px-6 lg:px-8">
      <div className="flex w-full items-center justify-between gap-4">
        <div className="flex min-w-0 shrink-0 items-center gap-4 overflow-hidden">
          <div className="shrink-0 origin-left scale-[0.6]">
            <BrandLockup
              size="sm"
              centered
              showTagline
              showSupportCopy={false}
              layout="stacked"
            />
          </div>

          <div className="min-w-0 truncate text-sm font-semibold text-slate-700 dark:text-slate-300">
            {shouldShowScopedEmployeeId ? (
              <EmployeeIdLabel employeeId={employeeSystemId} />
            ) : null}

            {firstName ? (
              <span className={shouldShowScopedEmployeeId ? "ml-2" : ""}>
                {firstName}
              </span>
            ) : null}
          </div>
        </div>

        {searchSlot ? (
          <div className="hidden min-w-0 flex-1 justify-center md:flex">
            <div className="relative w-full max-w-xl">
              {searchSlot}
            </div>
          </div>
        ) : null}

        <div className="ml-auto flex shrink-0 items-center gap-2">
          <PayrollNotificationsButton companyId={companyId} />
          <button
            type="button"
            onClick={onLogout}
            className="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-black uppercase tracking-wider text-slate-700 transition hover:bg-slate-100 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-900"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
